// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @08.08.2019 07:18:41
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class ResourcePlanningInfo_abstract extends BaseObject {
  static $t: string = 'SagaBase.Defines.ResourcePlanningInfo';
  $t: string = 'SagaBase.Defines.ResourcePlanningInfo';

  public static GetMembers(): string[] {
    return ['PeriodStartUtc', 'PeriodEndUtc', 'MainSchedules', 'ServiceSchedules', 'AssociatedCrews'];
  }

  public GetMembers(): string[] {
    return ResourcePlanningInfo_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    this.PeriodStartUtc = this.PeriodStartUtc && new Date(this.PeriodStartUtc);
    this.PeriodEndUtc = this.PeriodEndUtc && new Date(this.PeriodEndUtc);

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public PeriodStartUtc: Date = new Date();
  public PeriodEndUtc: Date = new Date();
  public MainSchedules: any[];
  public ServiceSchedules: any[];
  public AssociatedCrews: any[];

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
